import React, { Component } from "react";
import { Form, FormGroup, FormControl, Jumbotron, Button } from "react-bootstrap";
import axios from "axios";
import BaseUrl from "../../Stores/DataStore/Enums/BaseUrl";
import CharacterReplacer from "../../Core/CharacterReplacer";

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = { savedPassword: false, disabled: false };
  }

  handlePassword1Change(e) {
    this.setState({ password1: e.target.value });
  }

  handlePassword2Change(e) {
    this.setState({ password2: e.target.value });
  }

  onSubmitClicked() {
    this.ResetPassword();
  }

  async ResetPassword() {
    this.setState({ savedPassword: false, disabled: false });
    const { password1, password2 } = this.state;

    try {
      const url = new URL(window.location);
      const requested_password_reset_id = url.searchParams.get("requested_password_reset_id");

      if (!requested_password_reset_id) throw Error("No requested_password_reset_id available");
      if (!password1 || !password2) throw Error("Please fill in all fields");
      if (password1 !== password2) throw Error("Passwords are not the same");
      let newpassword = CharacterReplacer.replaceForbiddenCharacters(password1);

      const baseUrl = new BaseUrl();
      const postUrl = baseUrl.SERVERURL + "/api/public/reset-password.php";

      await axios
        .post(
          postUrl,
          JSON.stringify({
            newpassword: newpassword,
            requestedpasswordresetid: requested_password_reset_id
          })
        )
        .then(
          async function(response) {
            if (response && response.data) {
              if (response.data.SavedPassword) {
                this.setState({ savedPassword: true, disabled: true });
              }
            }
          }.bind(this)
        )
        .catch(
          function(error) {
            if (error) {
              console.log(error);
              console.log(error.message);
            }

            if (error.response && error.response.headers) {
              this.setState({
                error: error.response.headers["x-error-message"]
              });
            }
          }.bind(this)
        );
    } catch (error) {
      if (error) {
        console.error(error);
        console.log(error.message);
      }

      this.setState({ error: error.message });
    }
  }

  onKeyPress(e) {
    if (e.key === "Enter") {
      this.ResetPassword();
    }
  }

  onBackToLogin() {
    this.props.onRefreshComponent(this.props.loginTypes.LOGIN.Name);
  }

  render() {
    const { error, disabled, savedPassword } = this.state;

    let errorMessage = null;
    if (error) errorMessage = <div className="alert alert-danger">{error}</div>;

    let savedMessage = null;
    if (savedPassword) savedMessage = <div className="alert alert-success">Password succesfully reset</div>;

    return (
      <div>
        <h1>Reset password</h1>
        <Form horizontal>
          <Jumbotron>
            <FormGroup controlId="formChangePasswordInput1">
              <FormControl
                type="password"
                placeholder="New password"
                onChange={this.handlePassword1Change.bind(this)}
                onKeyPress={this.onKeyPress.bind(this)}
              />
            </FormGroup>
            <FormGroup controlId="formChangePasswordInput2">
              <FormControl
                type="password"
                placeholder="Confirm new password"
                onChange={this.handlePassword2Change.bind(this)}
                onKeyPress={this.onKeyPress.bind(this)}
              />
            </FormGroup>
            <FormGroup controlId="formResetPasswordSubmit">
              <Button type="button" bsStyle="primary" onClick={this.onSubmitClicked.bind(this)} disabled={disabled}>
                Submit
              </Button>
            </FormGroup>
          </Jumbotron>
          <a onClick={this.onBackToLogin.bind(this)}>Back to login</a>
        </Form>
        {errorMessage}
        {savedMessage}
      </div>
    );
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/Components/ResetPassword/ResetPassword.js